

































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import NavbarWalletStatusIcon from '@/components/navbar/NavbarWalletStatusIcon.vue'
import {$} from '@/facade'
import {isNeoLineInAppBrowser} from '@/store/model/wallets/connection/NeoLineConnection'
import {WalletSessionSummary} from '@/model/wallets/types/WalletSessionSummary'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import NetworkToggle from '@/components/NetworkToggle.vue'

@Component({
  components: {
    NavbarWalletStatusIcon,
    NetworkToggle,
  },
})
export default class NavbarWalletSessionConnectedDropdown extends Vue {
  @Prop({type: Array, required: true}) sessions!: WalletSessionSummary[]
  @Prop({type: Array, required: true}) networks!: TWalletNetwork[]
  @Prop({type: String, required: true}) selectedNetwork!: TWalletNetwork

  get hasNetworkChoice(): boolean {
    return this.networks.length > 1
  }

  sessionTitle(session: WalletSessionSummary): string {
    return session.network === this.selectedNetwork
      ? `${session.label}:`
      : `${session.label} ${session.network}:`
  }

  get isNeoLineInApp() {
    return isNeoLineInAppBrowser()
  }

  canDisconnect(session: WalletSessionSummary): boolean {
    return !(this.isNeoLineInApp && session.walletImplementation === 'n3')
  }

  canConnect(session: WalletSessionSummary): boolean {
    return !(this.isNeoLineInApp && session.walletImplementation === 'neoX')
  }

  disconnect(session: WalletSessionSummary) {
    if (session.walletImplementation === 'n3') {
      $.walletAdapter.disconnectN3Wallet(session.network)
      return
    }

    $.walletAdapter.disconnectXWallet(session.network)
  }

  openConnectWalletModal(session: WalletSessionSummary) {
    // The modal takes over from here; leaving the panel open would uncover it
    // again once the modal closes, without the user having asked for it.
    this.$emit('close')

    $.modal.open('connectWalletModal', {
      walletImplementation: session.walletImplementation,
      network: session.network,
    })
  }
}
